import { useCallback, useState } from "react";
import type { CreateServiceRequest } from "@/types/api";
import { BedrockFields } from "./BedrockFields";
import { parseOptionalInt } from "./parseOptionalInt";

export function useBedrockFields() {
  const [accessKey, setAccessKey] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [region, setRegion] = useState("");
  const [modelId, setModelId] = useState("");
  const [maxTokens, setMaxTokens] = useState("");

  const toPayload = useCallback((): Partial<CreateServiceRequest> => {
    const payload: Partial<CreateServiceRequest> = {
      access_key: accessKey,
      secret_key: secretKey,
    };
    if (region) payload.region = region;
    if (modelId) payload.model_id = modelId;
    payload.max_tokens = parseOptionalInt(maxTokens);
    return payload;
  }, [accessKey, secretKey, region, modelId, maxTokens]);

  const fields = (
    <BedrockFields
      accessKey={accessKey}
      setAccessKey={setAccessKey}
      secretKey={secretKey}
      setSecretKey={setSecretKey}
      region={region}
      setRegion={setRegion}
      modelId={modelId}
      setModelId={setModelId}
      maxTokens={maxTokens}
      setMaxTokens={setMaxTokens}
    />
  );

  return { fields, toPayload };
}
